module.exports = __webpack_public_path__ + "img/Big Road.95a80968.png";